import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, captureInstallPrompt } from "@/lib/pwa";

// Capture the install prompt event ASAP — Chrome fires it once on load.
captureInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker after React boots.
registerServiceWorker();
